module.exports = __webpack_public_path__ + "static/Platnica-acc430c7c0810e5faea73789cf969990.jpg";